// MotoEbikes, Guildford showroom page interactions
(function () {
  // sticky nav background on scroll
  var nav = document.querySelector('.nav');
  var onScroll = function () {
    if (!nav) return;
    if (window.scrollY > 40) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  };
  if (nav) { window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

  // scroll reveal (respect reduced motion)
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  // FAQ: keep it an accordion (one open at a time) but allow all-closed
  var faqs = document.querySelectorAll('.faq .qa');
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();


// cursor spotlight on cards
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.card,.tcard,.qcard,.bcard,.cpanel,.fcard,.pcard,.lcard,.wb-tile');
  els.forEach(function(el){
    el.addEventListener('pointermove', function(e){
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });
})();


// ---- test-ride form: bike-type toggle, live progress, tailored success ----
(function(){
  var form = document.getElementById('trideForm');
  if (!form) return;

  var seg     = document.getElementById('trideSeg');
  var note    = document.getElementById('trideNote');
  var submit  = document.getElementById('trideSubmit');
  var bar     = document.getElementById('trideBar');
  var pct     = document.getElementById('tridePct');
  var done    = document.getElementById('trideDone');
  var doneSub = document.getElementById('trideDoneSub');
  var nextEl  = document.getElementById('trideNext');
  var fields  = ['trModel','trLicence','trWhen','trName','trContact']
                  .map(function(id){ return document.getElementById(id); });
  var type = 'road';

  var copy = {
    road: {
      note: '<b>Road legal bikes are tested right here</b> at our Guildford showroom, bring your licence and we’ll get you riding.',
      submit: 'Book my showroom test ride',
      doneSub: 'We’ve got your road-legal test ride request.',
      next: 'We’ll confirm the model’s availability and a showroom slot that suits you, usually the same day. Then just head to Unit H Perram Works, Merrow Lane, and ride.'
    },
    off: {
      note: '<b>Off-road bikes can’t be ridden on public roads.</b> So we’ll arrange a track or private-land session and guide you through location, gear and timing, start to finish.',
      submit: 'Plan my off-road ride',
      doneSub: 'We’ve got your off-road test ride request.',
      next: 'Off-road bikes can’t go on public roads, so we’ll line up a suitable track or private-land session and walk you through where, when and what to bring. We handle the awkward bits.'
    }
  };

  function setType(t){
    type = t;
    [].forEach.call(seg.children, function(b){ b.classList.toggle('on', b.dataset.type === t); });
    note.classList.toggle('off', t === 'off');
    note.innerHTML = copy[t].note;
    submit.textContent = copy[t].submit;
  }
  seg.addEventListener('click', function(e){
    var b = e.target.closest('button[data-type]');
    if (b) setType(b.dataset.type);
  });

  // the chosen bike determines road-legal vs off-road (each model is tagged).
  // in Shopify this maps to a per-product "road legal" metafield.
  var modelSel = document.getElementById('trModel');
  if (modelSel) modelSel.addEventListener('change', function(){
    var opt = modelSel.options[modelSel.selectedIndex];
    var t = opt && opt.getAttribute('data-type');
    if (t) setType(t);
  });

  // live progress, bike type counts as the first filled step (endowed progress)
  function progress(){
    var filled = 1; // type always chosen
    fields.forEach(function(f){ if (f && f.value.trim()) filled++; });
    var p = Math.round(filled / (fields.length + 1) * 100);
    bar.style.width = p + '%';
    pct.textContent = p + '%';
  }
  fields.forEach(function(f){
    if (!f) return;
    f.addEventListener('input', progress);
    f.addEventListener('change', progress);
  });
  progress();

  form.addEventListener('submit', function(e){
    e.preventDefault();
    bar.style.width = '100%';
    pct.textContent = '100%';
    doneSub.textContent = copy[type].doneSub;
    nextEl.textContent = copy[type].next;
    form.style.display = 'none';
    done.classList.add('show');
  });
})();


// ---- comparison chooser: best-for tabs highlight a recommended model ----
(function(){
  var tabs = document.getElementById('cmpTabs');
  var table = document.getElementById('cmpTable');
  if (!tabs || !table) return;
  var cols = [].slice.call(table.querySelectorAll('col'));
  var heads = [].slice.call(table.querySelectorAll('thead th'));
  function clear(){
    cols.forEach(function(c){ c.classList.remove('hl'); });
    heads.forEach(function(h){ h.classList.remove('hl'); });
    table.querySelectorAll('td.hl,th.hl').forEach(function(c){ c.classList.remove('hl'); });
    table.querySelectorAll('.pick').forEach(function(p){ p.remove(); });
  }
  function highlight(idx){
    clear();
    if (idx == null || idx < 0) return;
    // column index in table is idx+1 (first col is the row label)
    var col = idx + 1;
    if (cols[col]) cols[col].classList.add('hl');
    table.querySelectorAll('tr').forEach(function(tr){
      var cell = tr.children[col];
      if (cell) cell.classList.add('hl');
    });
  }
  tabs.addEventListener('click', function(e){
    var b = e.target.closest('.cmp-tab'); if (!b) return;
    [].forEach.call(tabs.children, function(x){ x.classList.toggle('on', x === b); });
    var idx = b.dataset.model;
    highlight(idx === '' || idx == null ? null : +idx);
    var label = b.dataset.label;
    if (label != null && idx != null && idx !== '') {
      var th = heads[(+idx) + 1];
      if (th) { var tag = document.createElement('span'); tag.className = 'pick'; tag.textContent = label; th.appendChild(tag); }
    }
  });
  // default: activate the first tab that has a model
  var first = tabs.querySelector('.cmp-tab[data-model]:not([data-model=""])');
  if (first) first.click();
})();


// ---- product compare toggles (visual selection state) ----
(function(){
  document.querySelectorAll('.pc-compare').forEach(function(btn){
    btn.addEventListener('click', function(){
      var on = btn.classList.toggle('on');
      var box = btn.querySelector('.box');
      if (box) box.textContent = on ? '✓' : '';
    });
  });
})();


// ---- finance calculator teaser (illustrative only, no committed rate) ----
(function(){
  var amt = document.getElementById('fcAmount');
  var term = document.getElementById('fcTerm');
  if (!amt || !term) return;
  var amtOut = document.getElementById('fcAmountOut');
  var termOut = document.getElementById('fcTermOut');
  var est = document.getElementById('fcEst');
  function fmt(n){ return n.toLocaleString('en-GB'); }
  function calc(){
    var P = +amt.value, m = +term.value;
    amtOut.textContent = '£' + fmt(P);
    termOut.textContent = m + ' mo';
    // illustrative flat estimate, clearly marked as an example, not a quote
    var perMonth = Math.round((P / m) * 1.09);
    est.innerHTML = '£' + fmt(perMonth) + '<small>/mo *</small>';
  }
  amt.addEventListener('input', calc);
  term.addEventListener('input', calc);
  calc();
})();


// ---- FAQ search + group filter ----
(function(){
  var search = document.getElementById('faqSearch');
  var chips = document.getElementById('faqGroups');
  var faqWrap = document.getElementById('faqList');
  if (!faqWrap) return;
  var qas = [].slice.call(faqWrap.querySelectorAll('.qa'));
  var empty = document.getElementById('faqEmpty');
  var group = 'all';
  function apply(){
    var q = (search ? search.value : '').trim().toLowerCase();
    var shown = 0;
    qas.forEach(function(d){
      var text = d.textContent.toLowerCase();
      var g = d.dataset.group || '';
      var okG = group === 'all' || g === group;
      var okQ = !q || text.indexOf(q) !== -1;
      var show = okG && okQ;
      d.classList.toggle('hide', !show);
      if (show) shown++;
      if (!show) d.open = false;
    });
    if (empty) empty.classList.toggle('show', shown === 0);
  }
  if (search) search.addEventListener('input', apply);
  if (chips) chips.addEventListener('click', function(e){
    var b = e.target.closest('.faq-chip'); if (!b) return;
    [].forEach.call(chips.children, function(x){ x.classList.toggle('on', x === b); });
    group = b.dataset.group || 'all';
    apply();
  });
})();


// ---- interactive licence route selector ----
(function(){
  var root = document.getElementById('licPath');
  if (!root) return;
  var cards = [].slice.call(root.querySelectorAll('[data-lp-card]'));
  var tabs  = [].slice.call(root.querySelectorAll('[data-lp-tab]'));
  var next  = root.querySelector('[data-lp-next]');
  var prev  = root.querySelector('[data-lp-prev]');
  var count = root.querySelector('[data-lp-count]');
  var bar   = root.querySelector('[data-lp-progress]');
  var line  = root.querySelector('[data-lp-line]');
  var total = cards.length;
  var i = 0;

  var labels = ['CBT · First step','A1 · Light motorcycle','A2 · Mid-power','A · Full licence'];
  var nextLabel  = next ? next.dataset.nextLabel  : 'Next →';
  var finalLabel = next ? next.dataset.finalLabel : 'View bikes →';
  var finalLink  = next ? next.dataset.finalLink  : '#';

  function set(n){
    if (n < 0) n = 0;
    if (n > total - 1) n = total - 1;
    i = n;
    cards.forEach(function(c,x){ c.classList.toggle('is-active', x === i); });
    tabs.forEach(function(t,x){ t.classList.toggle('is-active', x === i); t.setAttribute('aria-selected', x === i ? 'true' : 'false'); });
    if (count) count.textContent = labels[i] || '';
    if (bar) bar.style.width = ((i + 1) / total * 100) + '%';
    if (line) line.style.width = (total > 1 ? (i / (total - 1) * 100) : 0) + '%';
    if (prev) prev.disabled = (i === 0);
    if (next){
      var last = (i === total - 1);
      next.textContent = last ? finalLabel : nextLabel;
      next.classList.toggle('is-final', last);
    }
  }
  if (next) next.addEventListener('click', function(){
    if (i === total - 1){ if (finalLink){ location.hash = finalLink.replace('#',''); } }
    else set(i + 1);
  });
  if (prev) prev.addEventListener('click', function(){ set(i - 1); });
  tabs.forEach(function(t){ t.addEventListener('click', function(){ set(+t.dataset.lpTab); }); });

  // keyboard: left/right arrows when a tab is focused
  root.querySelector('.lp-track').addEventListener('keydown', function(e){
    if (e.key === 'ArrowRight'){ set(i + 1); tabs[i].focus(); }
    else if (e.key === 'ArrowLeft'){ set(i - 1); tabs[i].focus(); }
  });

  set(0);
})();


// ---- road vs off-road interactive toggle ----
(function(){
  var root = document.getElementById('rvo');
  if (!root) return;
  var btns = [].slice.call(root.querySelectorAll('[data-rvo]'));
  var wm = root.querySelector('[data-rvo-wm]');
  var labels = { road: 'ROAD LEGAL', off: 'OFF-ROAD' };
  function set(mode){
    root.setAttribute('data-mode', mode);
    btns.forEach(function(b){ b.classList.toggle('on', b.dataset.rvo === mode); });
    root.querySelectorAll('[data-rvo-c]').forEach(function(c){ c.classList.toggle('on', c.dataset.rvoC === mode); });
    root.querySelectorAll('[data-rvo-v]').forEach(function(v){ v.classList.toggle('on', v.dataset.rvoV === mode); });
    if (wm) wm.textContent = labels[mode];
  }
  btns.forEach(function(b){ b.addEventListener('click', function(){ set(b.dataset.rvo); }); });
})();


// ---- interactive ownership console (with animated visuals) ----
(function(){
  var root = document.getElementById('own2');
  if (!root) return;
  var tabs = [].slice.call(root.querySelectorAll('[data-own]'));
  var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var i = 0, started = false;
  var stage = root.querySelector('.own2-stage');
  var calcIndex = panels.findIndex(function(p){ return p.classList.contains('own2-panel--calc'); });

  function runViz(n){
    var p = panels[n];
    // battery fill + percentage
    var batt = p.querySelector('[data-batt]');
    if (batt){
      var pctEl = p.querySelector('[data-batt-pct]');
      batt.style.height = '0%';
      if (pctEl) pctEl.textContent = '0%';
      requestAnimationFrame(function(){
        setTimeout(function(){
          batt.style.height = '100%';
          if (pctEl){
            if (reduce){ pctEl.textContent = '100%'; return; }
            var v = 0, t0 = performance.now(), dur = 2400;
            (function tick(now){
              var k = Math.min(1, (now - t0) / dur);
              pctEl.textContent = Math.round(k * 100) + '%';
              if (k < 1) requestAnimationFrame(tick);
            })(t0);
          }
        }, 120);
      });
    }
    // running-cost calculator
    if (p.classList.contains('own2-panel--calc') && root._recalc){ root._recalc(true); }
    // maintenance ticks (sequential)
    var checks = [].slice.call(p.querySelectorAll('[data-chk]'));
    checks.forEach(function(c){ c.classList.remove('on'); });
    checks.forEach(function(c, x){ setTimeout(function(){ c.classList.add('on'); }, reduce ? 0 : 250 + x * 320); });
  }

  function set(n){
    i = n;
    tabs.forEach(function(t,x){ t.classList.toggle('is-active', x === i); t.setAttribute('aria-selected', x === i ? 'true':'false'); });
    panels.forEach(function(p,x){ p.classList.toggle('is-active', x === i); });
    if (stage) stage.classList.toggle('is-tall', i === calcIndex);
    runViz(i);
  }
  tabs.forEach(function(t){ t.addEventListener('click', function(){ set(+t.dataset.own); }); });

  // ---- running-cost calculator ----
  (function(){
    var panel = root.querySelector('.own2-panel--calc');
    if (!panel) return;
    var fuelIn = panel.querySelector('[data-fuel]');
    var hoursIn = panel.querySelector('[data-hours]');
    var hoursOut = panel.querySelector('[data-cc-hours]');
    var bars = [].slice.call(panel.querySelectorAll('[data-ccbar]'));
    var vals = [].slice.call(panel.querySelectorAll('[data-ccval]'));
    var svg = panel.querySelector('[data-chart]');

    // per-hour cost model (illustrative, see footnote)
    // total = (fuelLitresPerHour * fuelPrice + maintenancePerHour) * hours
    var MODEL = [
      { fuel: 0,   maint: 5.40  },   // Sur-Ron (electricity folded into maint, fuel-price independent)
      { fuel: 3.5, maint: 54.435 },  // 450 4-stroke
      { fuel: 5.0, maint: 122.20 }   // 250 2-stroke
    ];
    function money(n){ return '£' + Math.round(n).toLocaleString('en-GB'); }
    function totals(fuel, hours){ return MODEL.map(function(m){ return (m.fuel * fuel + m.maint) * hours; }); }

    function drawChart(fuel, hours){
      var W = 520, H = 250, padL = 6, padR = 6, padT = 12, padB = 22;
      var pw = W - padL - padR, ph = H - padT - padB;
      var end = totals(fuel, hours);
      var maxY = Math.max(end[2], 1);
      var steps = Math.min(hours, 120);
      var s = '';
      // gridlines + labels
      for (var g = 0; g <= 4; g++){
        var yv = maxY * g / 4;
        var y = (padT + ph - (yv / maxY) * ph).toFixed(1);
        s += '<line class="cc-grid-line" x1="' + padL + '" y1="' + y + '" x2="' + (W - padR) + '" y2="' + y + '"/>';
        var lbl = yv >= 1000 ? '£' + (yv / 1000).toFixed(yv >= 10000 ? 0 : 1) + 'k' : '£' + Math.round(yv);
        s += '<text class="cc-axis-lbl" x="' + padL + '" y="' + (y - 4) + '">' + lbl + '</text>';
      }
      // plots
      var cls = ['elec', 'p1', 'p2'];
      for (var b = 0; b < MODEL.length; b++){
        var pts = '';
        for (var i = 0; i <= steps; i++){
          var h = hours * i / steps;
          var v = (MODEL[b].fuel * fuel + MODEL[b].maint) * h;
          var x = (padL + pw * i / steps).toFixed(1);
          var yy = (padT + ph - (v / maxY) * ph).toFixed(1);
          pts += x + ',' + yy + ' ';
        }
        s += '<polyline class="cc-plot ' + cls[b] + '" points="' + pts.trim() + '"/>';
      }
      svg.innerHTML = s;
    }

    function recalc(animate){
      var fuel = Math.max(0, parseFloat(fuelIn.value) || 0);
      var hours = Math.max(1, Math.min(500, parseInt(hoursIn.value, 10) || 1));
      var t = totals(fuel, hours);
      var maxT = Math.max(t[2], 1);
      if (hoursOut) hoursOut.textContent = hours;
      vals.forEach(function(el, i){ el.textContent = money(t[i]); });
      bars.forEach(function(el, i){
        var w = Math.max(3, t[i] / maxT * 100);
        if (animate){ el.style.width = '0'; requestAnimationFrame(function(){ setTimeout(function(){ el.style.width = w + '%'; }, 120); }); }
        else { el.style.width = w + '%'; }
      });
      drawChart(fuel, hours);
    }
    root._recalc = recalc;
    var defaults = { fuel: fuelIn.value, hours: hoursIn.value };
    fuelIn.addEventListener('input', function(){ recalc(false); });
    hoursIn.addEventListener('input', function(){ recalc(false); });
    panel.querySelectorAll('[data-reset]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.getAttribute('data-reset') === 'fuel') fuelIn.value = defaults.fuel;
        else hoursIn.value = defaults.hours;
        recalc(false);
      });
    });
    recalc(false);
  })();

  // start first animation when scrolled into view
  if (reduce || !('IntersectionObserver' in window)){ set(0); }
  else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting && !started){ started = true; set(0); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(root);
  }
})();


// ---- immersive "Buy with complete confidence" storytelling ----
(function(){
  var cf = document.getElementById('why');
  if (!cf || !cf.classList.contains('cf')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // review wall content (editable placeholders — never invent names/quotes)
  var wall = [
    { src: 'Google', who: '[Reviewer name]' },
    { src: 'Trustindex', who: '[Reviewer name]' },
    { src: 'BirdEye', who: '[Reviewer name]' },
    { src: 'Google', who: '[Reviewer name]' },
    { src: 'Google', who: '[Reviewer name]' },
    { src: 'Trustindex', who: '[Reviewer name]' }
  ];
  function card(r){
    return '<div class="cf-rev"><div class="top"><span class="src">'+r.src+'</span><span class="stars">★★★★★</span></div>'
      + '<p>[Replace with a genuine customer review from '+r.src+'.]</p>'
      + '<div class="who">'+r.who+'</div></div>';
  }
  cf.querySelectorAll('.cf-wall-col').forEach(function(col, ci){
    // duplicate the set so the vertical marquee loops seamlessly
    var set = wall.map(function(r,i){ return card(wall[(i+ci)%wall.length]); }).join('');
    col.innerHTML = set + set;
  });

  // intro crossfade: stage A -> stage B as the tall intro scrolls
  var intro = cf.querySelector('.cf-intro');
  var A = cf.querySelector('[data-cf-a]'), B = cf.querySelector('[data-cf-b]');
  var cue = cf.querySelector('.cf-scrollcue');
  var vh = window.innerHeight;
  var ticking = false;
  function onScroll(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){
      ticking = false;
      if (intro && A && B && !reduce){
        var total = intro.offsetHeight - vh;
        if (total <= 40){ A.style.opacity = 1; A.style.transform = 'none'; return; }
        var r = intro.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -r.top / total));
        var t = Math.min(1, p / 0.55);              // A fades out over first 55%
        var t2 = Math.max(0, (p - 0.45) / 0.55);    // B fades in after 45%
        A.style.opacity = (1 - t).toFixed(3);
        A.style.transform = 'translateY(' + (-50 - t * 8) + '%) scale(' + (1 - t * 0.06).toFixed(3) + ')';
        B.style.opacity = Math.min(1, t2).toFixed(3);
        B.style.transform = 'translateY(' + (-50 + (1 - Math.min(1,t2)) * 8) + '%) scale(' + (0.96 + Math.min(1,t2) * 0.04).toFixed(3) + ')';
        if (cue) cue.style.opacity = (1 - Math.min(1, p * 2)).toFixed(2);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function(){ vh = window.innerHeight; onScroll(); });
  onScroll();
})();

// ---- confidence deck: init EVERY [data-cf-deck] on the page (multi-instance safe) ----
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vh = window.innerHeight;
  var decks = [].slice.call(document.querySelectorAll('[data-cf-deck]'));
  decks.forEach(function(deck){
    if (deck.dataset.cfInit === '1') return;
    deck.dataset.cfInit = '1';
    var slides = [].slice.call(deck.querySelectorAll('.cf-panel'));
    if (!slides.length) return;
    var dotsWrap = deck.querySelector('[data-cf-dots]');
    var curEl = deck.querySelector('[data-cf-cur]');
    var totalEl = deck.querySelector('[data-cf-total]');
    var nextBtn = deck.querySelector('[data-cf-next]');
    var prevBtn = deck.querySelector('[data-cf-prev]');
    var idx = 0;
    if (totalEl) totalEl.textContent = ('0' + slides.length).slice(-2);
    var dots = slides.map(function(_, i){
      var d = document.createElement('button');
      d.type = 'button'; d.setAttribute('aria-label', 'Reason ' + (i + 1));
      d.addEventListener('click', function(){ go(i); });
      if (dotsWrap) dotsWrap.appendChild(d);
      return d;
    });
    function go(n){
      idx = (n + slides.length) % slides.length;
      slides.forEach(function(s, i){ s.classList.toggle('active', i === idx); s.classList.toggle('in', i === idx); });
      dots.forEach(function(d, i){ d.classList.toggle('on', i === idx); });
      if (curEl) curEl.textContent = ('0' + (idx + 1)).slice(-2);
    }
    if (nextBtn) nextBtn.addEventListener('click', function(){ go(idx + 1); });
    if (prevBtn) prevBtn.addEventListener('click', function(){ go(idx - 1); });
    slides.forEach(function(s){
      s.addEventListener('click', function(e){ if (e.target.closest('a,button')) return; go(idx + 1); });
    });
    document.addEventListener('keydown', function(e){
      var r = deck.getBoundingClientRect();
      if (r.top > vh * 0.6 || r.bottom < vh * 0.4) return;
      if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
    });
    var sx = null;
    deck.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, { passive: true });
    deck.addEventListener('touchend', function(e){
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 44) go(idx + (dx < 0 ? 1 : -1));
      sx = null;
    });
    go(0);

    // brand cycler inside this deck (panel 02), if present
    var section = deck.closest('.cf') || deck.parentNode;
    var cycle = section.querySelector('.cf-cycle');
    var tabs = section.querySelector('[data-cf-brands]');
    if (cycle && tabs){
      var word = cycle.querySelector('.cf-word');
      var brands = [].slice.call(tabs.children).map(function(b){ return b.textContent; });
      var bi = 0, timer;
      function show(n){
        bi = (n + brands.length) % brands.length;
        word.style.transition = 'opacity .25s ease, transform .25s ease';
        word.style.opacity = '0'; word.style.transform = 'translateY(-8px)';
        setTimeout(function(){
          word.textContent = brands[bi];
          word.style.transform = 'translateY(8px)';
          requestAnimationFrame(function(){ word.style.opacity = '1'; word.style.transform = 'none'; });
        }, 220);
        [].forEach.call(tabs.children, function(b,i){ b.classList.toggle('on', i === bi); });
      }
      function loop(){ timer = setInterval(function(){ show(bi + 1); }, 2000); }
      tabs.addEventListener('click', function(e){
        var b = e.target.closest('button'); if (!b) return;
        clearInterval(timer); show([].indexOf.call(tabs.children, b)); loop();
      });
      if (!reduce) loop();
    }
  });
})();